<template>
  <div class="custom-margin-full-page mt-16">
    <v-row>
      <v-col cols="12" class="text-center">
        دوره های شما :
      </v-col>
      <v-col cols="6" v-for="course in courses"
             :key="course.course.id">
        <v-card class="my-4 mx-8 custom-rounded" elevation="1" color="#1ab69d">
          <v-card-title class="white--text">
            {{ course.course.title }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="white--text">
                <img class="rounded constructor-image" :src="course.course.cover_file"
                     :alt="course.course.title"/>
              </v-col>
              <v-col cols="12" class="white--text">
                {{ course.course.details }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>

      <v-col cols="12" class="text-center">
        مربیان شما :
      </v-col>
      <v-col cols="6" v-for="instructor in instructors"
             :key="instructor.instructor.id">
        <v-card class="my-4 mx-8 custom-rounded" elevation="1" color="#1ab69d">
          <v-card-title class="white--text">
            <v-row>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12" class="small-text-custom mb-0 pb-0">
                    {{ instructor.instructor.name }}
                  </v-col>
                  <v-col cols="12" class="x-small-text-custom mt-o pt-0">
                    {{ instructor.instructor.email }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <img class="rounded constructor-image" :src="instructor.instructor.profile_image"
                     :alt="instructor.instructor.name"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="white--text">
                {{ instructor.instructor.details }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CoursesAndInstructorsDesktop",
  data() {
    return {
      courses: [],
      instructors: []
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      window.axios.get('student/details/courses-instructors').then((res) => {
        this.courses = res.data.data.course_details
        this.instructors = res.data.data.instructor_details
      })
    }
  }
}
</script>

<style scoped>
.custom-rounded {
  border-radius: 20px !important;
}

.small-text-custom {
  font-size: 1.2vw;
}

.x-small-text-custom {
  font-size: 1vw;
}

.custom-margin-full-page {
  margin: 0 10vw 0 10vw;
}

.constructor-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>